import axios from "axios";

import { envConfig } from "../constants";

export const Post = (api_url, post, cb) => {
  axios
    .post(
      `${envConfig.API_BASE_URL}${api_url}`,
      { ...post },
      {
        withCredentials: true,
        headers: { Accept: "application/json" },
      },
    )
    .then((res) => {
      cb(true, res.data);
      console.log(api_url, res.data);
    })
    .catch(function (error) {
      console.log(error);
      if (error.response) {
        console.log(error.response);
        cb(false, error.response);
      } else {
        cb(false, {});
      }
    });
};

export const GetAuthApi = (api_url, cb) => {
  axios
    .get(`${envConfig.API_BASE_URL}${api_url}`, {
      withCredentials: true,
      headers: { Accept: "application/json" },
    })
    .then((res) => {
      cb(true, res.data);
      console.log(api_url, res.data);
    })
    .catch(function (error) {
      console.log(error);
      if (error.response) {
        console.log(error.response);
        cb(false, error.response);
      } else {
        cb(false, {});
      }
    });
};

export const Get_API = (api_url, post, cb) => {
  axios
    .get(`${envConfig.API_BASE_URL}${api_url}`, {
      withCredentials: true,
      headers: { Accept: "application/json" },
    })
    .then((res) => {
      cb(true, res.data);
    })
    .catch(function (error) {
      console.log(error);
      if (error.response) {
        console.log(error.response);
        cb(false, error.response);
      } else {
        cb(false, {});
      }
    });
};
